// src/pages/Settings.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Company from './settings/CompanySettings';
import ExchangeRate from './settings/ExchangeRate';
import Features from './settings/Features';
import PaymentMethods from './settings/PaymentMethods';
import PriceLevels from './settings/PriceLevels';
import Locations from './settings/Locations';
import Users from './settings/Users';
import Backup from './settings/Backup';
import PrinterSettings from './settings/PrinterSettings';
import { isLocalInstall } from '../config/api';

const GREEN = '#2e9f86';

export default function Settings() {
  const { t } = useTranslation();

  const tabs = [
    { key: 'company',   label: t('settings.company',        'Company'),          Comp: Company },
    { key: 'exchange',  label: t('settings.exchangeRate',   'Exchange Rate'),    Comp: ExchangeRate },
    { key: 'features',  label: t('settings.features',       'Features'),         Comp: Features },
    { key: 'methods',   label: t('settings.paymentMethods', 'Payment Methods'),  Comp: PaymentMethods },
    { key: 'levels',    label: t('settings.priceLevels',    'Price Levels'),     Comp: PriceLevels },
    { key: 'locations', label: t('settings.locations',      'Locations'),        Comp: Locations },
    { key: 'users',     label: t('settings.users',          'Users'),            Comp: Users },
    { key: 'backup',    label: t('settings.backup',         'Backup'),           Comp: Backup },
    { key: 'printers', label: 'Printers', Comp: PrinterSettings },
  ];

  const [active, setActive] = useState(tabs[0].key);
  const Current = tabs.find((x) => x.key === active)?.Comp || (() => null);

  return (
    <div>
      <div className="px-5 pt-5">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">{t('settings.title', 'Settings')}</h1>

        {/* tab bar */}
        <div className="flex gap-1 border-b overflow-x-auto">
          {tabs.map((tb) => {
            const isActive = tb.key === active;
            return (
              <button key={tb.key} onClick={() => setActive(tb.key)}
                      className={`px-4 py-2 text-sm font-semibold whitespace-nowrap border-b-2 -mb-px transition
                                  ${isActive ? '' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                      style={isActive ? { color: GREEN, borderColor: GREEN } : {}}>
                {tb.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* active tab content */}
      <Current />
    </div>
  );
}